import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const icon = css`
  color: ${colors.gray.dark};
`;

export const textAndIcon = css`
  display: flex;

  > :first-child {
    margin-right: 10px;
  }
`;

export const headerItem = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  > :first-child {
    margin-bottom: 10px;
  }
`;

export const drawerHeader = css`
  display: flex;
`;
